import {
    CLAPI
} from '../clchart/cl.api.js'
import * as DATAS from '../datas/transdata.js'

export const easyMarketHead = [
    {
        label: '序号',
        field: 'index',
        maxchs: 4,
        align: 'center', // align 默认为'right'
        sort: 'resume',     // sort默认为 number  resume表示原来的序列
        getclr : 'getIntClr',
        getvar : 'getIntVar',  
    },
    {
        label: '代码',
        field: 'code',
        maxchs: 8,
        align: 'left',  // alignTxt 默认为'right'
        sort: 'string', 
        getclr : 'getCodeClr',
        getvar : 'getStrVar',  
    },
    {
        label: "名称",
        field: 'name',
        maxchs: 8,
        align: 'left',  // alignTxt 默认为'right'
        style: 'click',  // 返回 click 事件 返回 label 信息
        getclr : 'getNameClr',
        getvar : 'getStrVar',  
    },
    {
        label: '前收盘',
        field: 'agop',
        getclr : 'getPrcClr', 
        getvar : 'getPrcVar', 
    },
    {
        label: '当日价',
        field: 'newp',
        change: true,   // change:true 表示如果数值有变化，显示动画效果
        getclr : 'getPrcClr', 
        getvar : 'getPrcVar', 
    },
    {
        label: '当日涨幅',
        field: 'crate',
        getclr : 'getZeroClr', 
        getvar : 'getPctVar', 
    },
    {
        label: '最新价',
        field: 'nowp',
        change: true,   // change:true 表示如果数值有变化，显示动画效果
        getclr : 'getPrcClr', 
        getvar : 'getPrcVar', 
    },
    {
        label: '总涨幅',
        field: 'wrate',
        getclr : 'getZeroClr', 
        getvar : 'getPctVar', 
    },
    {
        label: '涨停价',
        field: 'stopup',
        change: true,   // change:true 表示如果数值有变化，显示动画效果
        getclr : 'getPrcClr', 
        getvar : 'getPrcVar', 
    },
    {
        label: '跌停价',
        field: 'stopdn',
        change: true,   // change:true 表示如果数值有变化，显示动画效果
        getclr : 'getPrcClr', 
        getvar : 'getPrcVar', 
    },
    {
        label: '成交金额',
        field: 'newmny',
        change: true,   // change:true 表示如果数值有变化，显示动画效果
        getclr : 'getVolClr', 
        getvar : 'getSrcVolVar', 
    },
    {
        label: '盘口金额',
        field: 'newmmp',
        getclr : 'getVolClr', 
        getvar : 'getSrcVolVar', 
    },
    {
        label: '每股收益',
        field: 'income',
        getclr : 'getZeroClr', 
        getvar : 'getPrcVar', 
    },
    {
        label: '每股资产',
        field: 'assets',
        getclr : 'getPrcClr', 
        getvar : 'getPrcVar', 
    },
    {
        label: '总股本',
        field: 'wstake',
        getclr : 'getVolClr', 
        getvar : 'getSrcVolVar', 
    },
    {
        label: '流通股本',
        field: 'fstake',
        getclr : 'getVolClr', 
        getvar : 'getSrcVolVar', 
    },
]

export const selectMarketHead = [
    {
        label: '序号',
        field: 'index',
        maxchs: 4,
        align: 'center', // align 默认为'right'
        sort: 'resume',     // sort默认为 number  resume表示原来的序列
        getclr : 'getIntClr',
        getvar : 'getIntVar',  
    },
    {
        label: '代码',
        field: 'code',
        maxchs: 8,
        align: 'left',  // alignTxt 默认为'right'
        sort: 'string', 
        getclr : 'getCodeClr',
        getvar : 'getStrVar',  
    },
    {
        label: "名称",
        field: 'name',
        maxchs: 8,
        align: 'left',  // alignTxt 默认为'right'
        style: 'click',  // 返回 click 事件 返回 label 信息
        getclr : 'getNameClr',
        getvar : 'getStrVar',  
    },
    {
        label: '前收盘',
        field: 'agop',
        getclr : 'getPrcClr', 
        getvar : 'getPrcVar', 
    },
    {
        label: '当日价',
        field: 'newp',
        change: true,   // change:true 表示如果数值有变化，显示动画效果
        getclr : 'getPrcClr', 
        getvar : 'getPrcVar', 
    },
    {
        label: '当日涨幅',
        field: 'crate',
        getclr : 'getZeroClr', 
        getvar : 'getPctVar', 
    },
    {
        label: '最新价',
        field: 'nowp',
        change: true,   // change:true 表示如果数值有变化，显示动画效果
        getclr : 'getPrcClr', 
        getvar : 'getPrcVar', 
    },
    {
        label: '累计涨幅',
        field: 'wrate',
        getclr : 'getZeroClr', 
        getvar : 'getPctVar', 
    },
    {
        label: '入选日期',
        field: 'selday',
        getclr : 'getCodeClr', 
        getvar : 'getIntVar', 
    },
    {
        label: '入选价',
        field: 'selprc',
        change: true,   // change:true 表示如果数值有变化，显示动画效果
        getclr : 'getPrcClr', 
        getvar : 'getPrcVar', 
    },
    {
        label: '涨停价',
        field: 'stopup',
        change: true,   // change:true 表示如果数值有变化，显示动画效果
        getclr : 'getPrcClr', 
        getvar : 'getPrcVar', 
    },
    {
        label: '跌停价',
        field: 'stopdn',
        change: true,   // change:true 表示如果数值有变化，显示动画效果
        getclr : 'getPrcClr', 
        getvar : 'getPrcVar', 
    },
    {
        label: '成交金额',
        field: 'newmny',
        change: true,   // change:true 表示如果数值有变化，显示动画效果
        getclr : 'getVolClr', 
        getvar : 'getSrcVolVar', 
    },
    {
        label: '盘口金额',
        field: 'newmmp',
        getclr : 'getVolClr', 
        getvar : 'getSrcVolVar', 
    },
    {
        label: '每股收益',
        field: 'income',
        getclr : 'getZeroClr', 
        getvar : 'getPrcVar', 
    },
    {
        label: '每股资产',
        field: 'assets',
        getclr : 'getPrcClr', 
        getvar : 'getPrcVar', 
    },
    {
        label: '总股本',
        field: 'wstake',
        getclr : 'getVolClr', 
        getvar : 'getSrcVolVar', 
    },
    {
        label: '流通股本',
        field: 'fstake',
        getclr : 'getVolClr', 
        getvar : 'getSrcVolVar', 
    },
]

export const adjustMarketHead = [
    {
        label: '序号',
        field: 'index',
        maxchs: 4,
        align: 'center', // align 默认为'right'
        sort: 'resume',     // sort默认为 number  resume表示原来的序列
        getclr : 'getIntClr',
        getvar : 'getIntVar',  
    },
    {
        label: '代码',
        field: 'code',
        maxchs: 8,
        align: 'left',  // alignTxt 默认为'right'
        sort: 'string', 
        getclr : 'getCodeClr',
        getvar : 'getStrVar',  
    },
    {
        label: "名称",
        field: 'name',
        maxchs: 8,
        align: 'left',  // alignTxt 默认为'right'
        style: 'click',  // 返回 click 事件 返回 label 信息
        getclr : 'getNameClr',
        getvar : 'getStrVar',  
    },
    {
        label: '持仓成本',
        field: 'curavgp',
        getclr : 'getPrcClr', 
        getvar : 'getPrcVar', 
    },
    {
        label: '持仓量',
        field: 'curvol',
        getclr : 'getVolClr', 
        getvar : 'getSrcVolVar', 
    },
    {
        label: '最高价',
        field: 'curmaxp',
        change: true,   // change:true 表示如果数值有变化，显示动画效果
        getclr : 'getPrcClr', 
        getvar : 'getPrcVar', 
    },
    {
        label: '当日涨幅',
        field: 'crate',
        getclr : 'getZeroClr', 
        getvar : 'getPctVar', 
    },
    {
        label: '最新价',
        field: 'nowp',
        change: true,   // change:true 表示如果数值有变化，显示动画效果
        getclr : 'getPrcClr', 
        getvar : 'getPrcVar', 
    },
    {
        label: '累计涨幅',
        field: 'wrate',
        getclr : 'getZeroClr', 
        getvar : 'getPctVar', 
    },
    {
        label: '涨停价',
        field: 'stopup',
        change: true,   // change:true 表示如果数值有变化，显示动画效果
        getclr : 'getPrcClr', 
        getvar : 'getPrcVar', 
    },
    {
        label: '跌停价',
        field: 'stopdn',
        change: true,   // change:true 表示如果数值有变化，显示动画效果
        getclr : 'getPrcClr', 
        getvar : 'getPrcVar', 
    },
    {
        label: '成交金额',
        field: 'newmny',
        change: true,   // change:true 表示如果数值有变化，显示动画效果
        getclr : 'getVolClr', 
        getvar : 'getSrcVolVar', 
    },
    {
        label: '盘口金额',
        field: 'newmmp',
        getclr : 'getVolClr', 
        getvar : 'getSrcVolVar', 
    },
    {
        label: '每股收益',
        field: 'income',
        getclr : 'getZeroClr', 
        getvar : 'getPrcVar', 
    },
    {
        label: '每股资产',
        field: 'assets',
        getclr : 'getPrcClr', 
        getvar : 'getPrcVar', 
    },
    {
        label: '总股本',
        field: 'wstake',
        getclr : 'getVolClr', 
        getvar : 'getSrcVolVar', 
    },
    {
        label: '流通股本',
        field: 'fstake',
        getclr : 'getVolClr', 
        getvar : 'getSrcVolVar', 
    },
]

export const TrendHead1 = [
    {
        label: '序号',
        field: 'index',
        maxchs: 4,
        align: 'center', // align 默认为'right'
        sort: 'resume',     // sort默认为 number  resume表示原来的序列
        getclr : 'getIntClr',
        getvar : 'getIntVar',  
    },
    {
        label: '代码',
        field: 'code',
        maxchs: 8,
        align: 'left',  // alignTxt 默认为'right'
        sort: 'string', 
        getclr : 'getCodeClr',
        getvar : 'getStrVar',  
    },
    {
        label: "名称",
        field: 'name',
        maxchs: 8,
        align: 'left',  // alignTxt 默认为'right'
        style: 'click',  // 返回 click 事件 返回 label 信息
        getclr : 'getNameClr',
        getvar : 'getStrVar',  
    },
    {
        label: '次数',
        maxchs: 4,
        field: 'nums',
        getclr : 'getIntClr', 
        getvar : 'getIntVar', 
    },
    {
        label: '时间',
        maxchs: 5,
        field: 'msec',
        getclr : 'getCodeClr', 
        getvar : 'getMinuVar', 
    },
    {
        label: '最新价',
        field: 'newp',
        change: true,   // change:true 表示如果数值有变化，显示动画效果
        getclr : 'getPrcClr', 
        getvar : 'getPrcVar', 
    },
    {
        label: '涨幅',
        field: 'rate',
        getclr : 'getZeroClr', 
        getvar : 'getPctVar', 
    },
    {
        label: '主力资金',
        field: 'curr_bigm',
        getclr : 'getZeroClr', 
        getvar : 'getMnyVar',
    },
    {
        label: '5日资金',
        field: 'fast_bigm',
        getclr : 'getZeroClr', 
        getvar : 'getMnyVar',
    },
    {
        label: '5日趋势',
        field: 'fast_emzf',
        getclr : 'getZeroClr',  // 默认调用 getFltClr 表示浮点数
        getvar : 'getFltVar',   
    },
    {
        label: '5日涨幅',
        field: 'fast_sumf',
        getclr : 'getZeroClr',  // 默认调用 getFltClr 表示浮点数
        getvar : 'getFltVar',   
    },
    {
        label: '本现价比',
        field: 'area_snpr',
        getclr : 'getOneClr', 
        getvar : 'getFltVar',
    },
    {
        label: '涨跌幅比',
        field: 'updn_zf_r',
        getclr : 'getOneClr', 
        getvar : 'getFltVar',
    },
    {
        label: '市场情绪',
        field: 'mood_sumf',
        getclr : 'getZeroClr', 
        getvar : 'getFltVar', 
    },
    {
        label: '能量合计',
        field: 'emny_summ',
        getclr : 'getZeroClr', 
        getvar : 'getFltVar', 
    },
    {
        label: '意愿差额',
        field: 'ep_backzf',
        getclr : 'getZeroClr', 
        getvar : 'getFltVar', 
    },
];


export const TrendHead2 = [
    {
        label: '序号',
        field: 'index',
        maxchs: 4,
        align: 'center', // align 默认为'right'
        sort: 'resume',     // sort默认为 number  resume表示原来的序列
        getclr : 'getIntClr',
        getvar : 'getIntVar',  
    },
    {
        label: '代码',
        field: 'code',
        maxchs: 8,
        align: 'left',  // alignTxt 默认为'right'
        sort: 'string', 
        getclr : 'getCodeClr',
        getvar : 'getStrVar',  
    },
    {
        label: "名称",
        field: 'name',
        maxchs: 8,
        align: 'left',  // alignTxt 默认为'right'
        style: 'click',  // 返回 click 事件 返回 label 信息
        getclr : 'getNameClr',
        getvar : 'getStrVar',  
    },
    {
        label: '时间',
        maxchs: 5,
        field: 'msec',
        getclr : 'getCodeClr', 
        getvar : 'getMinuVar', 
    },
    {
        label: '最新价',
        field: 'newp',
        change: true,   // change:true 表示如果数值有变化，显示动画效果
        getclr : 'getPrcClr', 
        getvar : 'getPrcVar', 
    },
    {
        label: '涨幅',
        field: 'rate',
        getclr : 'getZeroClr', 
        getvar : 'getPctVar', 
    },
    {
        label: '本现价比',
        field: 'area_snpr',
        getclr : 'getNegClr', 
        getvar : 'getFltVar',
    },
    {
        label: '涨跌幅比',
        field: 'updn_zf_r',
        getclr : 'getNegClr', 
        getvar : 'getFltVar',
    },
    {
        label: '当日资金',
        field: 'curr_bigm',
        getclr : 'getPosClr', 
        getvar : 'getMnyVar',
    },
    {
        label: '5日趋势',
        field: 'fast_emzf',
        getclr : 'getPosClr',  // 默认调用 getFltClr 表示浮点数
        getvar : 'getFltVar',   
    },
    {
        label: '5日涨幅',
        field: 'fast_sumf',
        getclr : 'getPosClr',  // 默认调用 getFltClr 表示浮点数
        getvar : 'getFltVar',   
    },
    {
        label: '能量合计',
        field: 'emny_summ',
        getclr : 'getPosClr', 
        getvar : 'getFltVar', 
    },
    {
        label: '涨跌卖比',
        field: 'updn_sm_r',
        getclr : 'getPosClr', 
        getvar : 'getFltVar', 
    },
    {
        label: '市场情绪',
        field: 'mood_sumf',
        getclr : 'getPosClr', 
        getvar : 'getFltVar', 
    },
    {
        label: '5日波动',
        field: 'fast_emzr',
        getclr : 'getPosClr', 
        getvar : 'getFltVar', 
    },
];